export default [
	{
		action: 'read',
		route: 'locations',
		title: 'Sucursales',
		resource: 'Home',
		icon: 'ShoppingBagIcon',
	},
	{
		action: 'read',
		route: 'holiday',
		resource: 'Home',
		title: 'Horario Personalizado',
		icon: 'CalendarIcon',
	}
]
